/*import './style.local.scss';*/
import React from 'react';
import content from '../../../content/main.archie';
import CoveredVideoPlayer from '../CoveredVideoPlayer/CoveredVideoPlayer.jsx';
import SlideShow from '../SlideShow/SlideShow.jsx';
import ParallaxContainer from '../ParallaxContainer/ParallaxContainer.jsx';
import ParallaxItem from '../ParallaxItem/ParallaxItem.jsx';
import SizeGiver from '../../containers/SizeGiver/SizeGiver.jsx';
import AppBar from '../AppBar/AppBar.jsx';
import Inset from '../Inset/Inset.jsx';
import SubInset from '../SubInset/SubInset.jsx';
import LineChart from '../charting/LineChart/LineChart.jsx';
import SVGChart from '../charting/SVGChart/SVGChart.jsx';
import ShipChart from '../special/ShipChart/ShipChart.jsx';
import GlobeChart from '../special/GlobeChart/GlobeChart.jsx';
import PortCityProfiles from '../special/PortCityProfiles/PortCityProfiles.jsx';
import CoverPage from '../special/CoverPage/CoverPage.jsx';
import TrafficChart from '../special/TrafficChart/TrafficChart.jsx';
import AQIChart from '../special/AQIChart/AQIChart.jsx';
import HealthIntro from '../special/HealthIntro/HealthIntro.jsx';
import WorldIntro from '../special/WorldIntro/WorldIntro.jsx';
import YouIntro from '../special/YouIntro/YouIntro.jsx';
import GlobeStory from '../special/GlobeStory/GlobeStory.jsx';
import PortStory from '../special/PortStory/PortStory.jsx';
import HealthSolutions from '../special/HealthSolutions/HealthSolutions.jsx';
import HealthSolutions2 from '../special/HealthSolutions2/HealthSolutions2.jsx';
import ClimateTalks from '../special/ClimateTalks/ClimateTalks.jsx';
import ClimateTalks2 from '../special/ClimateTalks2/ClimateTalks2.jsx';
import IMOStory from '../special/IMOStory/IMOStory.jsx';
import YouSolutions from '../special/YouSolutions/YouSolutions.jsx';
import MailForm from '../MailForm/MailForm.jsx';
import PictureFrame from '../PictureFrame/PictureFrame.jsx';
import Intro from '../special/Intro/Intro.jsx';
import Credits from '../special/Credits/Credits.jsx';

export default class App extends React.Component {
  constructor(props,context) {
    super(props,context);
    this.props=props;
    this.context=context;
  }
  render() {
    return (
      <div>
        <AppBar />
        <CoverPage /> 
        <Intro/>
        <HealthIntro />
        <PortStory />
        <HealthSolutions />
        <HealthSolutions2 />
        <WorldIntro />
        <GlobeStory />
        <ClimateTalks />
        <IMOStory />
        <ClimateTalks2 />
        <div className="container">          
          <PictureFrame caption="Cargo ships can also have a more direct impact on coral reefs when they run aground. In 2015 a Vietnamese freighter collided with a coral reef in Legazpi, Phillipines, in one of the richest coral ecosystems in the world.">          
            <CoveredVideoPlayer slug="20160519aw-shipping-accident-legazpi">
              <img style={{width:"100%"}} src="images/video2-poster.jpg" />
            </CoveredVideoPlayer>
          </PictureFrame>
        </div>
        <YouIntro />
        <YouSolutions />
        <MailForm />
        <footer className="page-footer teal">
          <div className="container">
            <Credits />
          </div>
          <div className="page-footer-copyright">
            <div className="container">
              Copyright &copy; China Daily Asia 2016
            </div>
          </div>
        </footer>
      </div>
      
    );
  }
}

/*

  <div className="container body-text">
            <div className="section">
                <Inset hed="Port City Profiles" dek="How major Asian ports are tackling -- or failing to address -- shipping emissions." >
                    <PortCityProfiles/>
                </Inset>
                <PortStory />
            </div>
        </div>
        
*/

/*<div classNameName="container" dangerouslySetInnerHTML={{ __html: content.maintext.filter((d) => d.type=="text").map((d) => "<p>"+d.value+"</p>").reduce((prev,cur) => prev+cur)}}>
          
        </div>*/
        
/*
<CoveredVideoPlayer youtubeId="EFVqhUF6j4A">
                    <div style={{width:"100%",height:"100%",backgroundImage:"url(images/background1.jpg)",backgroundSize:"cover"}} />
                  </CoveredVideoPlayer>
                  
<SlideShow>
                    <div style={{width:"100%",height:"0",paddingBottom:"66.667%",backgroundImage:"url(images/background1.jpg)",backgroundSize:"cover"}} />
                    <div style={{width:"100%",height:"0",paddingBottom:"66.667%",backgroundImage:"url(images/background2.jpg)",backgroundSize:"cover"}} />
                    <div style={{width:"100%",height:"0",paddingBottom:"66.667%",backgroundImage:"url(images/background3.jpg)",backgroundSize:"cover"}} />  
                  </SlideShow>                  
                 */
                
/*<CoveredVideoPlayer slug="20160408aw_renewables">
            <div style={{width:"100%",height:"100%",backgroundImage:"url(images/background1.jpg)",backgroundSize:"cover"}} />
          </CoveredVideoPlayer>*/
          
          



// WEBPACK FOOTER //
// ./src/js/components/App/App.jsx